import React from "react";
import "./App.css";

function App () {
  return (
    <div className="container">
      <header className="header">
        <h1 className="company-name">TruFurrs</h1>
        <p className="tagline">Happier pet, Happier you</p>
      </header>

      <main className="main" id="home">
        <h2 className="coming-soon">🐾 Happiness is on its way! 🐾</h2>
        <p className="description">
          We are working hard to bring you the best pet products and services. Stay tuned for something amazing!
        </p>
        {/* <button className="notify-button">Notify Me</button> */}
      </main>

      <section className="contact" id="contact">
        <h2>Contact Us</h2>
        <p>Email: <a href="mailto:contact@trufurrs.com">contact@trufurrs.com</a></p>
      </section>

      <footer className="footer">
        <p>&copy; 2025 TruFurrs. All rights reserved.</p>
      </footer>
    </div>
  );
}

export default App;
